import { SVGProps } from 'react';

export const NoInvitees = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="142"
    height="141"
    viewBox="0 0 142 141"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="71" cy="70.5" r="70.5" fill="currentColor" fillOpacity="0.03" />
    <circle cx="71.5" cy="71" r="61" fill="currentColor" fillOpacity="0.05" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.729 53.25C101.53 53.25 99.5881 54.3225 98.3504 55.9529L91.4117 53.1796C91.4902 52.7598 91.5417 52.3346 91.5417 51.8958C91.5417 51.4571 91.4902 51.0319 91.4117 50.6121L98.3504 47.8387C99.5881 49.4692 101.53 50.5417 103.729 50.5417C107.464 50.5417 110.5 47.5056 110.5 43.7708C110.5 40.036 107.464 37 103.729 37C99.9944 37 96.9583 40.036 96.9583 43.7708C96.9583 43.8521 96.98 43.9306 96.9827 44.0119L89.4535 47.0235C88.2348 45.8535 86.5908 45.125 84.7708 45.125C81.036 45.125 78 48.161 78 51.8958C78 55.6306 81.036 58.6667 84.7708 58.6667C86.5908 58.6667 88.2348 57.9381 89.4535 56.7681L96.9827 59.7798C96.98 59.861 96.9583 59.9396 96.9583 60.0208C96.9583 63.7556 99.9944 66.7917 103.729 66.7917C107.464 66.7917 110.5 63.7556 110.5 60.0208C110.5 56.286 107.464 53.25 103.729 53.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.1673 80.3327C73.1419 80.3327 78.0007 75.4739 78.0007 69.4993C78.0007 63.5248 73.1419 58.666 67.1673 58.666C61.1927 58.666 56.334 63.5248 56.334 69.4993C56.334 75.4739 61.1927 80.3327 67.1673 80.3327Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.1667 83.041C54.4104 83.041 45.5 89.7225 45.5 99.291V101.999H88.8333V99.291C88.8333 89.7225 79.9229 83.041 67.1667 83.041Z"
      fill="currentColor"
    />
  </svg>
);
